import { render } from "./TimeCards.vue?vue&type=template&id=2d2ee700"
import script from "./TimeCards.vue?vue&type=script&lang=ts"
export * from "./TimeCards.vue?vue&type=script&lang=ts"
script.render = render

export default script